import React, { Component } from "react";
import Images from "../../Images";

export class FloatingText extends Component {
  render() {
    return (
      <div className="floating-text">
        <h2>{this.props.text}</h2>

        <span>Place A Bet <img src={Images.DownArrow} alt="right-arrow"/></span>
      </div>
    );
  }
}

export default FloatingText;
